$(document).ready(function () {
    $(".slick-slider").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        slidesPerRow: 1,
        dots: false,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 4000,
        rows: 2,
        centerPadding: '30px',
        lazyLoad: 'progressive',
        mobileFirst: true,
        pauseOnHover: false,
        nextArrow: '<button type="button" class="button--slider button--next" name="next" aria-label="Slide right"><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" viewBox="0 0 24 24" width="24" height="24" class=""><path d="M13.172 12l-4.95-4.95 1.414-1.414L16 12l-6.364 6.364-1.414-1.414z"></path></svg></button>',
        prevArrow: '<button type="button" class="button--slider button--prev" name="previous" aria-label="Slide left"><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" viewBox="0 0 24 24" width="24" height="24" class=""><path d="M13.172 12l-4.95-4.95 1.414-1.414L16 12l-6.364 6.364-1.414-1.414z"></path></svg></button>',
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    rows: 1,
                    slidesPerRow: 1,
                }
            },
        ]
    });
    $(window).on('load', function () {
        $("#splash").delay(500).fadeOut('slow', function () {
            $('.section--home-banner').addClass('appear');
            var h = $(window).height();
            $(".splashbg").css({
                "border-width": h,
                "animation-name": "backBoxAnime"
            });
        });
        $("#splash-logo").delay(200).fadeOut('slow');
    });
    setTimeout(function () {
        $(".blur").addClass("blur--active");
    }, 1000);
});



function isHomePage() {
    // Modify this with your home page URL
    const homeUrl = 'https://snb-develop.myshopify.com/';

    // Get the current URL
    const currentUrl = window.location.href;

    // Check if the current URL is the home page URL
    return currentUrl === homeUrl;
}

// Only run the code if the current page is the home page
if (isHomePage()) {
    // Code to run if it's the home page
    const lenis = new Lenis();

    lenis.on('scroll', (e) => {
        // console.log(e)
    });

    function raf(time) {
        lenis.raf(time);
        requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);
}